import { FiDialogsContainerBase } from '@fi-shared/fi-dialogs/fi-dialogs-container-base';
import { FiDialogsContentBase, FI_DIALOGS_CONTENT_DATA } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { Component, Inject, OnInit, ViewEncapsulation, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-data-field-group-edit-item-dialog-confirm-type-convert',
    templateUrl: './dialog-confirm-type-convert.component.html',
    styleUrls: ['./dialog-confirm-type-convert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DataFieldGroupEditItemDialogConfirmTypeConvertComponent
    extends FiDialogsContentBase<{ textId: string }, boolean>
    implements OnInit
{
    constructor(
        private matDialogRef: MatDialogRef<FiDialogsContainerBase<{ textId: string }, boolean>>,
        private appTextService: AppTextService,
        @Inject(FI_DIALOGS_CONTENT_DATA) public data: { textId: string },
        injector: Injector,
    ) {
        super(matDialogRef, data, injector);
    }

    confirmationTextModel: string = '';
    compareValue: string;

    ngOnInit() {
        this.compareValue = this.appTextService.get('common.verify').toUpperCase();
    }

    isYesButtonDisabled() {
        return this.confirmationTextModel !== this.compareValue;
    }
}
